import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledInput = styled.input`
  display: block;
  height: 42px;
  width: 100%;
  padding: 0 10px;
  margin-bottom: 25px;
  border: 0.5px solid #bbbbbb;
  border-radius: 5px;
  box-sizing: border-box;

  &::placeholder {
    font-weight: 300;
    color: #999999;
  }
`

const StyledLabel = styled.label`
  color: #666666;
  font-size: 11px;
`

const TextField = props => (
  <React.Fragment>
    <StyledLabel>{props.label}</StyledLabel>
    <StyledInput
      placeholder={props.placeholder}
      type={props.type}
      value={props.value}
      onChange={props.onChange}
      style={props.style}
      defaultValue={props.defaultValue}
    />
  </React.Fragment>
)

TextField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string
}

export default TextField



// WEBPACK FOOTER //
// ./src/components/typography/TextField.js